import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { OrderBump } from "@/interfaces/OrderBump"
import { useBot } from "./useBot"

const axios = useAxios()

export interface CreateOrderBumpDTO {
    name: string
    title: string
    acceptButtonText?: string
    declineButtonText?: string
    mediaUrl?: string
    mediaType?: 'image' | 'video'
    audioUrl?: string
    deliverables?: string
    amount: number
    botId: number
    triggerPaymentPlanId?: number
}

export interface UpdateOrderBumpDTO {
    name?: string
    title?: string
    acceptButtonText?: string
    declineButtonText?: string
    mediaUrl?: string
    mediaType?: 'image' | 'video'
    audioUrl?: string
    deliverables?: string
    amount?: number
    triggerPaymentPlanId?: number
}

export interface GetAllOrderBumpsParams {
    botId?: number
    page?: string
    perPage?: string
}

export function useOrderBump() {
    const { selectedBot } = useBot()

    const create = async (payload: CreateOrderBumpDTO, callback?: () => void) => {
        // Ensure botId is set from selectedBot if not provided (though form should provide it)
        if (!payload.botId && selectedBot.value) {
            payload.botId = selectedBot.value.id
        }

        await axios.post('/order-bumps', payload)

        if (callback) callback()
    }

    const update = async (id: number, payload: UpdateOrderBumpDTO) => {
        await axios.patch(`/order-bumps/${id}`, payload)
    }

    const destroy = async (id: number, callback?: () => void) => {
        await axios.delete(`/order-bumps/${id}`)

        if (callback) callback()
    }

    const getById = async (id: number): Promise<OrderBump> => {
        const response = await axios.get(`/order-bumps/${id}`)
        return response.data
    }

    const getAll = async (params?: GetAllOrderBumpsParams): Promise<OrderBump[]> => {
        // Inject botId if not present and we have a selected bot
        if (!params) params = {}
        if (!params.botId && selectedBot.value) {
            params.botId = selectedBot.value.id
        }

        const response = await axios.get(`/order-bumps`, { params })
        return response.data
    }

    return {
        create,
        update,
        getById,
        getAll,
        destroy
    }
}
